<template>
  <div class="container container-platform">
    <span
      class="item--close"
      @click="resetSearch"
      :class="{ timesHiden: !platforms_search.length }"
      ><font-awesome-icon
        id="user--btn-icon"
        class="item--close-icon"
        icon="times"
    /></span>

    <div class="content">
      <div class="platforms carousel">
        <ith-platform-skeleton v-show="!this.platforms_temp" />

        <div class="carousel__container">
          <template v-for="item in this.platforms_temp">
            <div
              class="carousel-item"
              :id="item.id"
              :key="item.id"
              @click="selectPlatform(item)"
            >
              <figure class="platforms--item">
                <img
                  class="platforms--img"
                  :src="item.imageUrl"
                  :alt="item.name"
                />
                <div class="platforms-overlay" :class="item.backClass">
                  <font-awesome-icon
                    class="platforms--icon"
                    :class="item.iconClass"
                    icon="check"
                  />
                </div>
              </figure>
            </div>
          </template>
        </div>
      </div>
      <button class="icon-carousel icon-prev" @click="prev">
        <font-awesome-icon icon="chevron-left" />
      </button>
      <button class="icon-carousel icon-next" @click="next">
        <font-awesome-icon icon="chevron-right" />
      </button>

      <div class="search-area">
        <div><h2 class="title-search-area">Search by OTT Platform</h2></div>
        <ith-seach-input-platforms />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data: () => ({
    carousel: { margin: 0 },
    platforms_search: []
  }),
  mounted() {
    // if (this.paramsMovies.platforms != "") {
    this.platforms_search = this.paramsMovies.platforms.split(",");
    this.resetSearch();
    // }
  },

  computed: mapState(["criteria", "paramsMovies", "platforms_temp"]),
  methods: {
    prev: function() {
      var last = this.platforms_temp.pop();
      this.platforms_temp.splice(0, 0, last);
    },
    next: function() {
      var first = this.platforms_temp.shift();
      this.platforms_temp.push(first);
    },

    resetSearch() {
      let item = document.getElementsByClassName("platforms-overlay");
      let icon = document.getElementsByClassName("platforms--icon");
      item.forEach(element => {
        element.classList.remove("active");
      });
      icon.forEach(element => {
        element.classList.remove("active-icon");
      });
      let params = {
        data: "",
        src: this.$route.name
      };
      this.platforms_search = [];
      this.$store.dispatch("FETCH_EDIT_PLATFORMS", params);
      this.$store.commit("editPlatformsActives", this.platforms_search);
    },
    selectPlatform(i) {
      let item = document.getElementById(i.id).children[0].children[1];
      let icon = item.children[0];
      item.classList.toggle("active");
      icon.classList.toggle("active-icon");

      const index = this.platforms_search.findIndex(
        element => element === i.name
      );
      if (index != -1) {
        this.platforms_search.splice(index, 1);
      } else {
        this.platforms_search.push(i.name);
      }
      let params = {
        data: this.platforms_search.toString(),
        src: this.$route.name
      };
      this.$store.dispatch("FETCH_EDIT_PLATFORMS", params);
      this.$store.commit("editPlatformsActives", this.platforms_search);
    }
  }
};
</script>

<style scoped>
.container-platform {
  padding-top: 30px;
  display: grid;
  grid-template-columns: 100%;
  justify-content: space-between;
  position: relative;
}
.content {
  background: rgb(44, 56, 72);
  background: linear-gradient(
    180deg,
    rgba(44, 56, 72, 1) 15%,
    rgba(26, 34, 44, 1) 100%
  );
  border-radius: 20px !important;
  border: 1px solid #738092 !important;
  position: relative;
  padding: 0px 10px;
}
h2 {
  color: white;
  font-weight: 400;
  font-size: 25px;
  padding: 0px 10px 0px 20px;
}
.platforms {
  padding-top: 15px;
  /* display: grid; */
  /* grid-template-columns: repeat(12, auto); */
  justify-content: start;
  column-gap: 10px;
  row-gap: 10px;
}
.platforms--item {
  width: 90px;
  height: 60px;
  margin: 0;
  position: relative;
}
.platforms--img {
  border-radius: 8px;
  cursor: pointer;
  object-fit: cover;
  width: 90px;
  height: 60px;
}

.platforms-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  z-index: 1000;
  background-color: rgba(32, 44, 59, 0.6);
  border: 1px solid #273241;
  width: 90px;
  height: 60px;
}
.platforms--icon {
  position: absolute;
  right: 4px;
  top: 2px;
  color: white;
  background-color: #147afc;
  border-radius: 50%;
  border: 2px solid #147afc;
  font-size: 0.8em;
  visibility: hidden;
}

.active {
  background-color: rgba(0, 0, 0, 0);
}

.active-icon {
  visibility: visible;
}
.search-area {
  width: 100%;
  display: grid;
  grid-template-columns: 350px auto;
  align-items: center;
}

.carousel {
  overflow: scroll;
  width: 100%;
  position: relative;
}

.carousel__container {
  transition: 450ms -webkit-transform;
  transition: 450ms transform;
  transition: 450ms transform, 450ms -webkit-transform;
  font-size: 0;
  white-space: nowrap;
  padding-bottom: 10px;
}

.carousel__container:hover .carousel-item:hover {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
  opacity: 1;
}

.carousel-item {
  border-radius: 15px;
  overflow: hidden;
  position: relative;
  display: inline-block;
  margin-right: 10px;
  font-size: 20px;
  cursor: pointer;
  transition: 450ms all;
  -webkit-transform-origin: center left;
  transform-origin: center left;
}

.carousel-item:hover ~ .carousel-item {
  -webkit-transform: translate3d(10px, 0, 0);
  transform: translate3d(10px, 0, 0);
}

.carousel-item__img {
  width: 95px;
  -o-object-fit: cover;
  object-fit: cover;
}

::-webkit-scrollbar {
  display: none;
}

.icon-prev {
  left: 5px;
}
.icon-carousel {
  background: rgba(0, 0, 0, 0.5);
  color: white;
  border: 1px solid #9e9e9e;
  padding: 5px;
  border-radius: 5px;
  cursor: pointer;
  position: absolute;
  z-index: 1000;
  top: 30px;
  height: 30px;
  width: 25px;
}
.icon-carousel:hover {
  background: rgba(0, 0, 0, 0.9);
  color: white;
}

.icon-next {
  right: 5px;
}

.item--close {
  justify-self: end;
  position: absolute;
  right: -10px;
  width: 25px;
  height: 25px;
  border: 1px solid #cdcdcd;
  border-radius: 20px;
  text-align: center;
  cursor: pointer;
  top: 20px;
  z-index: 1000;
  background: #2c3848;
}
.item--close-icon {
  font-size: 15px;
  padding-top: 5px;
  padding-bottom: 3px;
}
.timesHiden {
  visibility: hidden;
}

@media (min-width: 1264px) and (max-width: 1400px) {
  .platforms {
    grid-template-columns: repeat(10, auto);
    column-gap: 10px;
    row-gap: 10px;
  }
}
@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
  .platforms {
    /* grid-template-columns: repeat(6, auto); */
    column-gap: 10px;
    row-gap: 10px;
  }
}
@media (min-width: 600px) and (max-width: 960px) {
  .platforms {
    /* grid-template-columns: repeat(6, auto); */
    column-gap: 10px;
    row-gap: 10px;
  }
}

@media (max-width: 600px) {
  .container-platform {
    width: 98%;
  }
  .platforms {
    /* grid-template-columns: repeat(3, auto); */
    column-gap: 10px;
    row-gap: 10px;
    justify-content: space-evenly;
  }
  .search-area {
    width: 100%;
    display: grid;
    grid-template-columns: 90%;
    align-items: center;
    margin-bottom: 5%;
    padding: 0 2%;
  }
  .title-search-area {
    font-size: 0.8rem;
  }
  .item--close {
    right: 0;
  }
}
</style>
